import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { ExternalEntitiesService } from '@shared/services/external-entities.service';
import { firstValueFrom } from 'rxjs';
import { EntityType } from '@models/common/entity-type.enum';
import { ExternalSourceType } from '@models/integrations/external-source-type.enum';
import { ExternalEntity } from '@models/integrations/external-entity';
import { SubMenuItem } from '@models/ui-models/section-form-menu';

@Component({
  selector: 'app-xpm-card-profile',
  standalone: true,
  imports: [
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
  ],
  templateUrl: './xpm-card-profile.component.html',
  styleUrl: './xpm-card-profile.component.scss'
})
export class XpmCardProfileComponent{
  @Input() externalEntities!: ExternalEntity[];
  @Input() entityId!: string;
  @Input() entityNumber!: string | undefined;
  @Input() entityType!: EntityType
  @Input() disableControls = false;

  @Output() externalEntitiesChange = new EventEmitter<ExternalEntity[]>();
  @Output() onEntityRefreshed = new EventEmitter<void>();

  externalEntitiesService = inject(ExternalEntitiesService);

  lastSync = '';

  xpmMenu: SubMenuItem[] = [
    {
      title: 'Go to Profile',
      iconClass: 'icon ic-external-link-20',
      action: () => this.redirectToExternalProfile(),
      isVisable: () => this.isConnectedtoExtentedEntity()
    },
    {
      title: 'Refresh',
      iconClass: 'icon ic-refresh-20',
      action: () => { void this.refreshProfile(); },
      isVisable: () => this.isConnectedtoExtentedEntity()
    },
    {
      title: 'Unlink Profile',
      iconClass: 'icon ic-unlink-20',
      action: () =>  { void this.unlinkExternalProfile(); },
      isVisable: () => this.isConnectedtoExtentedEntity()
    },
    {
      title: 'Link Profile',
      iconClass: 'icon ic-link-20',
      action: () =>  { void this.linkExternalProfile() ; },
      isVisable: () => !this.isConnectedtoExtentedEntity()
    }
  ];

  getLastSyncDateMessage(): string {
    this.lastSync = this.externalEntitiesService.getLastSyncDateMessage(this.externalEntities, ExternalSourceType.Xpm);
    return this.lastSync;
  }

  updateEntities(newEntities: ExternalEntity[]): void {
    this.externalEntities = newEntities;
    this.externalEntitiesChange.emit(newEntities);
  }

  async refreshProfile() {
    await this.externalEntitiesService.refreshProfile(this.entityId, this.externalEntities, ExternalSourceType.Xpm);
    this.onEntityRefreshed.emit();
  }

  redirectToExternalProfile() {
    this.externalEntitiesService.redirectToExternalProfile(this.externalEntities, ExternalSourceType.Xpm);
  }

  async unlinkExternalProfile() {
    const upadtedEnteties = await this.externalEntitiesService.unlinkExternalProfile(this.entityId, this.externalEntities, ExternalSourceType.Xpm);
    this.updateEntities(upadtedEnteties);
  }

  async linkExternalProfile() {
    const newupadtedEntety = await firstValueFrom(this.externalEntitiesService.linkExternalProfile(this.entityId,
      this.entityNumber ?? '',
      ExternalSourceType.Xpm,
      this.entityType)
    );

    this.externalEntities.push(newupadtedEntety);
    this.externalEntitiesChange.emit(this.externalEntities);
  }

  isConnectedtoExtentedEntity(): boolean {
    return this.externalEntitiesService.isConnectedtoExtentedEntity(this.externalEntities, ExternalSourceType.Xpm);
  }

}
